module.exports = __webpack_public_path__ + "img/cspace-andriodtvstore.11975a29.svg";